// removed by extract-text-webpack-plugin
module.exports = {"root":"Sk0-HmAM5RwlaEfcaOsb4","in-flex":"_1Oo_gEVB0bXRab5nG9W-8M","inFlex":"_1Oo_gEVB0bXRab5nG9W-8M","logo":"duOsaCVBjz95UBFzoaexn","promotion":"_31Q61nphyuDOcf1cda4tHm"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideMenu/core/styles.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideMenu/core/styles.scss
// module chunks = 0